
export default function Footer(){
    return(
        <footer className="footer">
            <p>© 2025 Nick Torrens. All rights reserved. </p>
        </footer>
    )
}